import React from "react";
import { useThemeStore } from "../../store/themeStore";
import { isDarkTheme } from "../../config/themes";

// Map each icon id to the correct slice of the big sprite (minX minY width height)
export const iconViewBoxes = {
  // Linhas e Medidas
  Measure: "3 1151 26 26",
  Average_Line: "3 35 26 26",
  Callout: "3 63 26 26",
  Channel: "3 96 26 26",
  Channel_StdDev: "3 160 26 26",
  LineSans_Continuouos: "3 294 26 26",
  Crosshair: "3 128 26 26",
  LineSans_Horizontal: "3 203 26 26",
  LineSans: "3 228 26 26",
  LineSans_Ray: "3 261 26 26",
  LineSans_Segment: "3 327 26 26",

  // Padrões
  Fib_Retracement: "3 384 26 26",
  Fib_Extension: "3 416 26 26",
  Fib_Projection: "3 448 26 26",
  Fib_Arc: "3 482 26 26",
  Fib_Fan: "2 512 26 26",
  Fib_TimeZones: "4 543 26 26",
  Gann_Fan: "3 639 26 26",
  Tirone_Levels: "3 1088 26 26",

  // Geometria
  Shape_Elipse: "3 355 26 26",
  LineSans_Vertical: "14 319 26 26",
  Pitchfork: "3 639 26 26",
  Quadrant_Lines: "3 672 26 26",
  LineSans_Doodle: "3 165 26 26",
  Shape_Rectangle: "3 739 26 26",
  Regression_Line: "3 768 26 26",
  SpeedResistance_Arc: "2 964 26 26",
  SpeedResistance_Line: "2 1088 26 26",

  // Formas e Texto
  Direct_Select2: "2 1312 26 26",
  Text_Annotation: "3 0 26 26",
  Shape_Arrow: "3 965 26 26",
  Shape_Check: "3 803 26 26",
  Shape_Cross: "3 832 26 26",
  Shape_Focus: "3 865 26 26",
  Shape_Heart: "2 864 26 26",
  Shape_Star: "3 928 26 26",
  Time_Cycle: "3 1023 26 26",

  // Extra (if ever used)
  Trend_Line: "3 1088 26 26",

  // Alertas
  Alert_Bell: "3 1630 26 26",
};

const FALLBACK_VIEWBOX = "0 0 26 26";

const Icon = ({ iconId, size = 20, color, className = "", viewBox }) => {
  const { theme } = useThemeStore();
  const isDark = isDarkTheme(theme);
  const themeColor = color ?? (isDark ? "#ffffff" : "#1f2937"); // white on dark, dark gray on light

  if (!iconId) return null;

  const resolvedViewBox = viewBox || iconViewBoxes[iconId] || FALLBACK_VIEWBOX;
  // If we don't have a known viewBox mapping, render a simple fallback so the UI isn't empty.
  if (!iconViewBoxes[iconId] && !viewBox) {
    const fallbackText =
      (iconId && iconId.toString().replace(/[^A-Z0-9]/gi, "")[0]) || "?";
    return (
      <svg
        viewBox={FALLBACK_VIEWBOX}
        fill="currentColor"
        preserveAspectRatio="xMidYMid meet"
        className={className}
        style={{
          color: themeColor,
          width: `${size}px`,
          height: `${size}px`,
          display: "inline-block",
        }}
        aria-hidden="true"
      >
        <circle cx="13" cy="13" r="12" fill={themeColor} opacity={0.12} />
        <text
          x="50%"
          y="55%"
          textAnchor="middle"
          alignmentBaseline="middle"
          fontSize={10}
          fill={themeColor}
        >
          {fallbackText}
        </text>
      </svg>
    );
  }

  return (
    <svg
      viewBox={resolvedViewBox}
      fill="currentColor"
      preserveAspectRatio="xMidYMid meet"
      className={className}
      style={{
        color: themeColor,
        width: `${size}px`,
        height: `${size}px`,
        display: "inline-block",
      }}
      aria-hidden="true"
    >
      <use
        href={`/objects.svg#${iconId}`}
        xlinkHref={`/objects.svg#${iconId}`}
      />
    </svg>
  );
};

export default Icon;
